var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{staticClass:"white rounded-lg"},[_c('v-list-item-content',[_c('v-list-item-subtitle',[_vm._v("Usuário selecionado")]),_c('v-list-item-title',{staticClass:"title"},[_vm._v(_vm._s(_vm.usuarioLogado.usuario))])],1),_c('v-list-item-action',[(_vm.novopedido.produtos.length == 0)?_c('trocar-usuario',{attrs:{"icon":""}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }